// @flow

import React, { useEffect } from 'react';
import type { Node } from 'react';
import { useHistory } from 'react-router-dom';

import './style.scss';

import greatReads from 'content/greatReads';

import Title from 'components/Title';
import SearchForm from 'components/SearchForm';
import Button from 'components/Button';
import HowItWorksSteps from 'components/HowItWorksSteps';
import CookiesInfo from 'components/CookiesInfo';
import HighlihtedProjects from 'components/HighlihtedProjects';

/**
 * @function Home
 * @param {Object} props
 * @returns {Node}
 * @exports Home
 */

const Home = (): Node => {
  const history = useHistory();

  function submitSerachForm(e, { language, popularity }) {
    e.preventDefault();
    history.push(`search/${language}/${popularity}`);
    if (process.env.NODE_ENV === 'production') {
      window.analytics.track('Search for issue', {
        language,
        popularity,
      });
    }
  }

  useEffect(() => {
    if (process.env.NODE_ENV === 'production') window.analytics.page('Home');
  }, []);

  return (
    <main className="Home">
      <section className="Home__searchForm">
        <Title tag="h1" fontSize="l">
          Let &#39; s join to some open-source project!
        </Title>
        <Title tag="p" fontSize="s">
          Browse open issues meant for newcomers & start contributing
        </Title>
        <SearchForm onSubmit={submitSerachForm} />
        <div className="Home__quickLookup">
          <Button
            isRounded
            secondary
            to="search/javascript/low"
            onClick={() => {
              if (process.env.NODE_ENV === 'production') {
                window.analytics.track('Quick search', {
                  language: 'javascript',
                  popularity: 'low',
                });
              }
            }}
          >
            Javascript + Low
          </Button>
          <Button
            isRounded
            secondary
            to="search/python/low"
            onClick={() => {
              if (process.env.NODE_ENV === 'production') {
                window.analytics.track('Quick search', {
                  language: 'python',
                  popularity: 'low',
                });
              }
            }}
          >
            Python + Low
          </Button>
        </div>
      </section>
      <section className="Home__intro ">
        <div className="Home__box Home__box--black">
          <Title tag="h2" fontSize="s">
            <span role="img" aria-label="books">
              💡
            </span>
            Highlihted projects that need your help
          </Title>
          <HighlihtedProjects />
        </div>
        <div className="Home__box">
          <Title tag="h2" fontSize="s" isBlack>
            <span role="img" aria-label="books">
              ⚙️
            </span>
            How it works?
          </Title>
          <HowItWorksSteps isCompact isBlack />
          <Button to="/how-it-works">Read more</Button>
        </div>
        <div className="Home__box Home__box--black">
          <Title tag="h2" fontSize="s">
            <span role="img" aria-label="books">
              📚
            </span>
            Great reads about OSS
          </Title>
          <ul className="Home__articles-list ul-clear">
            {greatReads.articles.slice(0, 6).map(({ name, url }) => (
              <Button isTargetBlank isText href={url} iconFill="primary">
                {name}
              </Button>
            ))}
          </ul>
          <Button to="/great-reads">Read more</Button>
        </div>
        {/* <div className="Home__box Home__box--1">
          <Title tag="h2" fontSize="s" isBlack>
            <span role="img" aria-label="books">
              🎉
            </span>
            Repo of the day
          </Title>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
            ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
            aliquip ex ea commodo consequat. Duis aute irure dolor in
            reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
            pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
            culpa qui officia deserunt mollit anim id est laborum.
          </p>
        </div> */}
      </section>
      <CookiesInfo />
    </main>
  );
};

export default Home;
